import { AlertBox } from 'components/UI/Alerts';
import { FunctionComponent } from 'react';

export interface NoPhoneAlertProps {
    onAddPhoneNumber?: () => void;
    className?: string;
}

export const NoPhoneAlert: FunctionComponent<NoPhoneAlertProps> = props => {
    return (
        <AlertBox
            text={
                <>
                    This client does not have a phone number added. Please{' '}
                    <span
                        onClick={props.onAddPhoneNumber}
                        style={{
                            cursor: 'pointer',
                            textDecoration: 'underline',
                            fontWeight: '600'
                        }}
                    >
                        add
                    </span>{' '}
                    it to send the pay by link.
                </>
            }
            actionable={false}
            className={props.className}
        />
    );
};

export default NoPhoneAlert;
